module.exports = __webpack_public_path__ + "assets/617e3e6d95fc2dbede171322529a1172.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./~/@ergeon/erg-theme/app/fonts/Quadon-Bold.woff
 ** module id = 1740
 ** module chunks = 1
 **/